require('intersection-observer');
import setupDealerLocatorForm from '../../../modules/dealer-locators/find-dealer-search-box';

export default async function() {
    setupDealerLocatorForm(document.getElementById('find-dealer-form'));

    const mapElement = document.getElementById('map');
    if (!mapElement) {
        return;
    }

    const googleClass = await GoogleMapsLoader.getMap();

    const mapObserver = new IntersectionObserver(
        function(entries) {
            if (!entries[0].intersectionRatio) {
                return;
            }
            initMap();
            mapObserver.unobserve(mapElement)
        },
        {
            threshold: 0.1
        }
    );

    mapObserver.observe(mapElement)

    async function initMap() {
        const bounds = new googleClass.maps.LatLngBounds();

        const map = new googleClass.maps.Map(mapElement, {
            zoom: 6,
            center: new googleClass.maps.LatLng(centre_lat, centre_lng),
            mapTypeId: googleClass.maps.MapTypeId.ROADMAP,
            scrollwheel:false,
            draggable:false,
        });

        const locationData = await window.LocationDataLoader.get();

        locationData.forEach(location => {
            if (location.offers_new != 'Y' || location.brand != brand) {
                return;
            }
            bounds.extend({lat: parseFloat(location.lat), lng: parseFloat(location.lng)});
        });

        map.fitBounds(bounds);

        googleClass.maps.event.addListener(map, 'click', function(event){
            this.setOptions({
                scrollwheel:true,
                draggable:true,
            });
        });


        const infowindow = new googleClass.maps.InfoWindow();

        let marker, i;

        for (i = 0; i < locationData.length; i++) {
            if (locationData[i]['brand'] == brand && locationData[i]['offers_new'] == 'Y') {
                // if (brand == 'ds') {
                //     let activeMarkers = [];
                //     marker = new googleClass.maps.Marker({
                //         position: new googleClass.maps.LatLng(locationData[i]['lat'], locationData[i]['lng']),
                //         map: map,
                //         icon: await getMapIcon(brand),
                //     });
                //     googleClass.maps.event.addListener(marker, 'click', (function (marker, i) {
                //         return function () {
                //             if(activeMarkers.length > 0){
                //                 activeMarkers[0].setIcon(await getMapIcon(brand));
                //                 activeMarkers.shift();
                //             }
                //             activeMarkers.push(marker);
                //             marker.setIcon("/img/ds/icons/map-pin-active.png");
                //             infowindow.setContent(getDealerUrl(locationData[i]));
                //             infowindow.open(map, marker);
                //         }
                //     })(marker, i));
                // } else {
                    marker = new googleClass.maps.Marker({
                        position: new googleClass.maps.LatLng(locationData[i]['lat'], locationData[i]['lng']),
                        map: map,
                        icon: await getMapIcon(brand)
                    });
                    googleClass.maps.event.addListener(marker, 'click', (function(marker, i) {
                        return function() {
                            infowindow.setContent(getDealerUrl(locationData[i]));
                            infowindow.open(map, marker);
                        }
                    })(marker, i));
                // }
            }
        }
    }

    function getDealerUrl(dealer) {
        return `<a href="/${dealer['full_slug']}">${dealer['name']}</a>`
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/details/setup-dealer-map.js